import React from 'react';
import * as ReactDOM from 'react-dom';

import './reset.css';
import './index.css';

// eslint-disable-next-line import/first
import 'bulma/css/bulma.css';

import App from './App';
// import registerServiceWorker from './registerServiceWorker';

// eslint-disable-next-line react/jsx-filename-extension
ReactDOM.render(<App />, document.getElementById('root'));
// Don't turn on PWA capabilities yet
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js